<template>
    <span :class="getFlagIconClass(countryCode)"></span>
</template>

<script>
    export default {
        name: "country",
        props: ["countryCode"],
        methods: {
            getFlagIconClass(countryCode) {
                return "flag-icon flag-icon-" + countryCode.toLowerCase();
            },
        },
    };
</script>

<style scoped></style>
